import React from "react"
import {Button, Modal} from "react-bootstrap"

import {analysisPdfPrintExtended, resultsPdfPrintConsultations} from '../utils/pdf.js'

import {ScanResultContext} from '../context/ScanResultContext'

export default class DownloadPdf extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleShow = this.handleShow.bind(this)
    this.handleHide = this.handleHide.bind(this)
    this.handleModal = this.handleModal.bind(this)
    this.resultsPdfPrintConsultations = resultsPdfPrintConsultations.bind(this)
    this.analysisPdfPrintExtended = analysisPdfPrintExtended.bind(this)

    this.state = {show: false}
  }

  handleModal() {
    if (this.props.type === "consultations") {
      setTimeout(function () {
        resultsPdfPrintConsultations()
      }, 1000)
    }
    if (this.props.type === "analysis") {
      setTimeout(function () {
        analysisPdfPrintExtended()
      }, 1000)
    }
    this.handleHide()
  }

  handleHide() {
    this.setState({show: false})
  }

  handleShow() {
    this.setState({show: true})
  }

  render() {
    const buttonDisabled = this.props.disabled ? this.props.disabled : false
    return (
      <ScanResultContext.Consumer>
        {context => (
          <div>
            <Button bsStyle={this.props.buttonstyle}
                    disabled={buttonDisabled}
                    onClick={this.handleShow}>
              {this.props.textbtn}
            </Button>
            <Modal
              {...this.props}
              show={this.state.show}
              onHide={this.handleHide}
              dialogClassName="custom-modal"
              backdrop={false}
            >
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-lg">
                  {this.props.title}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div dangerouslySetInnerHTML={{__html: this.props.text}}/>
              </Modal.Body>
              <Modal.Footer>
                <Button bsStyle="primary" onClick={(e) => {
                  context.showPrintView()
                  this.handleModal()
                  setTimeout(function () {
                    context.hidePrintView()
                  }, 3000)
                }}>
                  Downloaden
                </Button>
                <Button onClick={this.handleHide}>Annuleren</Button>
              </Modal.Footer>
            </Modal>
          </div>
        )}
      </ScanResultContext.Consumer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DownloadPdf.js